import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=5376e53c&scoped=true"
import script from "./Cases.vue?vue&type=script&lang=js"
export * from "./Cases.vue?vue&type=script&lang=js"
import style0 from "./Cases.vue?vue&type=style&index=0&id=5376e53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5376e53c",
  null
  
)

export default component.exports